// Folder reads and filing go to v2; the backend checks ownership and names.
import { requestV2 } from './v2-only.ts'

export const myFolders = (token: string, which: 'public' | 'private') =>
  requestV2(
    () => import('./folders-v2.ts'),
    (loaded) => loaded.myFolders(token, {}, which),
  )

/** One of the person's folders removed, in posts (`public`) or the private gallery; its items stay, in no folder. */
export const removeFolder = (
  token: string,
  which: 'public' | 'private',
  folder: string,
) =>
  requestV2(
    () => import('./folders-v2.ts'),
    (loaded) => loaded.removeFolder(token, {}, which, folder),
  )

export const fileInFolder = (
  token: string,
  how: 'move' | 'rename',
  images: string[],
  folder: string,
) =>
  requestV2(
    () => import('./folders-v2.ts'),
    (loaded) => loaded.fileInFolder(token, {}, how, images, folder),
  )
